import { Box, Rating, Stack, Typography } from "@mui/material";
import DefaultTextBold from "../../../../components/Accessibility/DefaultTextBold";
import { sxRating, sxText } from "../sxProps";
import { Avaliacao } from "../../../../interfaces/entities/SaudeOnline/AvaliacaoEspacoPersonal";
import { convertToNumber } from "../../../../utils/ConvertToNumber";

const AvaliacaoBox = ({ titulo, pergunta, media }: Avaliacao) => {
    return (
        <Box className='box-value'>
            <DefaultTextBold component="h3" text={titulo} />
            <Typography sx={sxText}>{pergunta}</Typography>
            <Stack spacing={1}>
                <Rating
                    name="size-medium"
                    defaultValue={convertToNumber(media)}
                    sx={sxRating}
                    precision={0.5}
                    readOnly
                />
            </Stack>
        </Box>
    );
};

export default AvaliacaoBox;